export default __webpack_public_path__ + "static/media/price-table.d8215b38.png";